body .ant-drawer {
  display: none;
}

.customer-lead-step__layout {
  flex: 1;

  display: grid;
  grid-template-columns: 4fr 18fr 11fr;
  grid-template-rows: min-content 1fr;

  // Sticky footer doesn't work without it
  overflow-x: clip;
}

.customer-lead-step__layout .customer-lead-step__layout__left {
  grid-area: 2 / 1 / 3 / 2;
}

.customer-lead-step__layout .customer-lead-step__layout__center {
  grid-area: 2 / 2 / 3 / 3;

  position: relative;

  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: stretch;

  gap: 16px;
}

.customer-lead-step__layout .customer-lead-step__layout__center__content {
  flex: 1;

  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: stretch;
}

.customer-lead-step__layout .customer-lead-step__layout__center__header__left-buttons {
  display: none;
}

.customer-lead-step__layout .customer-lead-step__layout__center__header__right-buttons {
  display: none;
}

.customer-lead-step__layout .customer-lead-step__layout__right {
  grid-area: 2 / 3 / 3 / 4;

  margin-top: 50px; // compensation for Tabs header
}

.customer-lead-step__layout .customer-lead-step__layout__center__header__backdrop {
  grid-area: 1 / 1 / 2 / 4;

  background-color: #F2F3F5;
  border-bottom: 1px solid #CCCFD8;
}

.customer-lead-step__layout .customer-lead-step__layout__center__header__container {
  grid-area: 1 / 2 / 2 / 3;

  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: stretch;

  gap: 16px;

  background-color: #F2F3F5;
  border-bottom: 1px solid #CCCFD8;

  padding: 16px 0;
}

.customer-lead-step__layout .customer-lead-step__layout__center__header {
  position: relative;

  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}

.customer-lead-step__layout__center__header .customer-lead-step__layout__center__header__logo {
  position: relative;
}

.customer-lead-step__layout__center__header .customer-lead-step__layout__center__header__logo-icon {
  border-radius: 50%;
  width: 40px;
  height: 40px;

  background-color: #22BDFF;
}

.customer-lead-step__layout__center__header .customer-lead-step__layout__center__header__logo-text {
  position: absolute;

  top: 14px;
  left: 10px;

  height: 14px;
  width: 140px;
}

.customer-lead-step__layout__center .customer-lead-step__layout__center__footer-actions {
  position: sticky;
  bottom: 0;

  display: flex;
  flex-flow: row-reverse nowrap;
  justify-content: flex-start;
  align-items: center;

  gap: 16px;

  background-color: #F2F3F5;

  margin: auto -100% 0;
  padding: 16px 100%;

  border-top: 1px solid #CCCFD8;
}

@media screen and (width <= 640px) {
  body .ant-drawer {
    display: unset;
  }

  .customer-lead-step__layout {
    padding: 16px;
    width: 100vw;

    grid-template-columns: 0 auto 0;
  }

  .customer-lead-step__layout .customer-lead-step__layout__left {
    display: none;
  }

  .customer-lead-step__layout .customer-lead-step__layout__center__header__backdrop {
    display: none;
  }

  .customer-lead-step__layout .customer-lead-step__layout__center__header__container {
    margin: -16px -16px 0;
    padding: 16px;
  }

  .customer-lead-step__layout .customer-lead-step__layout__center__header {
    display: grid;

    // 154px = logo text width + logo text left
    grid-template-columns: 1fr 154px 1fr;
    grid-template-rows: auto;

    gap: 32px;
  }

  .customer-lead-step__layout .customer-lead-step__layout__center {
    margin-right: 0;
    padding: 0;
  }

  .customer-lead-step__layout .customer-lead-step__layout__center__header__left-buttons {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;

    gap: 16px;
  }

  .customer-lead-step__layout .customer-lead-step__layout__center__header__right-buttons {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-end;
    align-items: center;

    gap: 16px;
  }

  .customer-lead-step__layout .customer-lead-step__layout__right {
    display: none;
  }

  .customer-lead-step__layout__center .customer-lead-step__layout__center__footer-actions {
    padding: 8px 16px;
    margin: auto -16px -16px;

    flex-flow: column nowrap;
    align-items: stretch;
  }
}

